var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C20 19.4695 19.7893 18.9608 19.4142 18.5858C19.0391 18.2107 18.5304 18 18 18H16C15.4696 18 14.9609 18.2107 14.5858 18.5858C14.2107 18.9608 14 19.4695 14 20M10.454 17.97C8.81341 18.046 7.17968 17.7126 5.7 17L1 18L2.3 14.1C-0.0239997 10.663 0.874 6.22797 4.4 3.72597C7.926 1.22497 12.99 1.42997 16.245 4.20597C17.912 5.62897 18.841 7.49997 18.992 9.42197M15 15C15 15.5304 15.2107 16.0391 15.5858 16.4142C15.9609 16.7893 16.4696 17 17 17C17.5304 17 18.0391 16.7893 18.4142 16.4142C18.7893 16.0391 19 15.5304 19 15C19 14.4695 18.7893 13.9608 18.4142 13.5858C18.0391 13.2107 17.5304 13 17 13C16.4696 13 15.9609 13.2107 15.5858 13.5858C15.2107 13.9608 15 14.4695 15 15Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserChat);
export default __webpack_public_path__ + "static/media/user-chat.04b600e7fe3eb1e233f2fb3c55bb160c.svg";
export { ForwardRef as ReactComponent };